<div class="h-100" style="display: flex; flex-direction: column">

  <div class="flex-row-space-between">

    <h1>Firmware</h1>

    <core-button-icon-big
      *ngIf="userCanEdit"
      id="button-create-firmware"
      (click)="onCreate()"
      [type]="InputButtonIconType.ADD">
    </core-button-icon-big>

  </div>

  <div class="row">

    <core-input-dropdown
      id="softwareType"
      class="col-2"
      topLabel="Software Typ"
      [options]="softwareTypeOptions"
      [(ngModel)]="selectedSoftwareType"
      (onKeyUpEnter)="onSearch()">
    </core-input-dropdown>

    <core-input-dropdown
      id="moduleType"
      class="col-2"
      topLabel="Modul Typ"
      [options]="moduleTypeOptions"
      optionValue="code"
      optionLabel="name"
      [(ngModel)]="selectedModuleTypeCode"
      (onKeyUpEnter)="onSearch()">
    </core-input-dropdown>

    <core-input-dropdown
      id="chipType"
      class="col-2"
      topLabel="Chip Typ"
      [options]="chipTypeOptions"
      optionValue="code"
      optionLabel="name"
      [(ngModel)]="selectedChipTypeCode"
      (onKeyUpEnter)="onSearch()">
    </core-input-dropdown>

    <core-input-dropdown
      id="displayType"
      class="col-2"
      topLabel="Display Typ"
      [options]="displayTypeOptions"
      optionValue="code"
      optionLabel="name"
      [(ngModel)]="selectedDisplayTypeCode"
      (onKeyUpEnter)="onSearch()">
    </core-input-dropdown>

    <core-input-text
      id="version"
      class="col-2"
      topLabel="Version"
      [(ngModel)]="selectedVersion"
      (onKeyUpEnter)="onSearch()">
    </core-input-text>

    <core-button
      (click)="onSearch()"
      [icon]="['fas', 'search']"
      [width]="'100%'"
      class="col-2"
      id="search"
      text="Suchen">
    </core-button>

  </div>

  <!-- Results -->
  <div #tableParentDiv class="h-100">
    <p-table
      (onLazyLoad)="searchLazy($event)"
      [(first)]="first"
      [autoLayout]="true"
      [lazy]="true"
      [loading]="loading"
      [paginator]="total > paginationSize"
      [rows]="paginationSize"
      [showCurrentPageReport]="true"
      [totalRecords]="total"
      [value]="firmwares"
      currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Firmwares"
      dataKey="id">

      <ng-template pTemplate="header">
        <tr>
          <th (click)="onSortOrderChanged('softwareType')">
            <span>
              <span>Software Typ</span>
              <span *ngIf="getSortIndexByFieldName('softwareType')">
                {{getSortIndexByFieldName('softwareType')}}
                <fa-icon [icon]="getSortIconByFieldName('softwareType')"></fa-icon>
              </span>
            </span>
          </th>
          <th>
            <span>
              <span>Modul Typ</span>
            </span>
          </th>
          <th>
            <span>
              <span>Chip Typ</span>
            </span>
          </th>
          <th>
            <span>
              <span>Display Typ</span>
            </span>
          </th>
          <th (click)="onSortOrderChanged('version')" style="width: 120px">
            <span>
              <span>Version</span>
              <span *ngIf="getSortIndexByFieldName('version')">
                {{getSortIndexByFieldName('version')}}
                <fa-icon [icon]="getSortIconByFieldName('version')"></fa-icon>
              </span>
            </span>
          </th>
          <th>Datei</th>
          <th
            [ngClass]="userCanEdit ? 'file-table-column-action-buttons-width' : 'file-table-column-action-buttons-width-without-edit-access'">
          </th>
        </tr>
      </ng-template>

      <ng-template let-item pTemplate="body">
        <tr *ngIf="!loading">
          <td style="width: 15%">{{item.softwareType}}</td>
          <td style="width: 15%">{{item.moduleTypeName}}</td>
          <td style="width: 15%">{{item.chipTypeName || '-'}}</td>
          <td style="width: 15%">{{item.displayTypeName || '-'}}</td>
          <td style="width: 10%">{{item.version}}</td>
          <td style="width: 20%">
            <a *ngIf="item.downloadUrl" [href]="item.downloadUrl" target="_blank" rel="noopener">{{item.fileName}}</a>
          </td>
          <td
            [ngClass]="userCanEdit ? 'file-table-column-action-buttons-width' : 'file-table-column-action-buttons-width-without-edit-access'"
            class="file-table-column-action-buttons">
            <core-button-icon
              (click)="onEdit(item)"
              [type]="userCanEdit ? InputButtonIconType.EDIT : InputButtonIconType.READ">
            </core-button-icon>
            <core-button-icon
              (click)="onDelete(item)"
              *ngIf="userCanEdit"
              [type]="InputButtonIconType.DELETE">
            </core-button-icon>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <ng-container *ngFor="let p of ArrayUtils.of(paginationSize)">
          <tr style="height: 40px">
            <td style="width: 15%"><p-skeleton></p-skeleton></td>
            <td style="width: 15%"><p-skeleton></p-skeleton></td>
            <td style="width: 15%"><p-skeleton></p-skeleton></td>
            <td style="width: 15%"><p-skeleton></p-skeleton></td>
            <td style="width: 10%"><p-skeleton></p-skeleton></td>
            <td style="width: 20%"><p-skeleton></p-skeleton></td>
            <td style="width: 10%"><p-skeleton></p-skeleton></td>
          </tr>
        </ng-container>
      </ng-template>

    </p-table>
  </div>
</div>
